const Organizations = Object.freeze({
    FINLAND: 1,
    DENMARK: 2,
    UK: 3
});

export default Organizations;